import { Shift } from './types';

export interface AbsenceTypeLike {
  code: string;
  isFullDay?: boolean;
  autoApply?: boolean;
  color?: string;
}

// Classe un Shift en midi/soir à partir des heures de début/fin de ses segments horaires.
// Extrait de PlanningModule.tsx (getShiftCounts) pour être réutilisé tel quel par la Feuille de route.
export const getShiftCounts = (shift: Shift | undefined, absenceTypes: AbsenceTypeLike[]) => {
    if (!shift) return { midi: 0, soir: 0 };
    let m = 0; let s = 0;
    const hasAbsence = shift.segments?.some(seg => (seg.label && absenceTypes.some(at => at.code === seg.label)) || seg.label === 'REPOS');
    if (hasAbsence) return { midi: 0, soir: 0 };

    const horaires = shift.segments?.filter(seg => seg.type === 'horaire') || [];
    if (horaires.length === 0) return { midi: 0, soir: 0 };

    const firstStart = horaires[0].start;
    const lastEnd = horaires[horaires.length - 1].end;
    if (!firstStart) return { midi: 0, soir: 0 };

    const isEvening = (time: string | undefined) => {
        if (!time || typeof time !== 'string') return false;
        const [h, min] = time.split(':').map(Number);
        if (isNaN(h)) return false;
        if (h < 6) return true; // past midnight
        return (h * 60 + (min || 0)) > 1140; // > 19:00
    };

    const hasEveningEnd = isEvening(lastEnd);

    if (firstStart < "12:00") {
        m = 1;
        if (hasEveningEnd) s = 1;
    } else if (firstStart >= "16:00") {
        s = 1;
    } else {
        if (hasEveningEnd) s = 1; else m = 1;
    }
    return { midi: m, soir: s };
};

// Un salarié est éligible à un service donné ce jour-là si son shift comporte au moins un segment horaire classé sur ce service.
export const isEmployeeOnService = (shift: Shift | undefined, service: 'midi' | 'soir', absenceTypes: AbsenceTypeLike[]) => {
    const counts = getShiftCounts(shift, absenceTypes);
    return service === 'midi' ? counts.midi > 0 : counts.soir > 0;
};

// Variante pour une feuille de route dont le service peut aussi être 'both' (toute feuille personnalisée
// créée via le "+" — demande d'Emeni : montrer tous les salariés présents ce jour-là, midi et soir
// confondus, sans réglage de service à choisir).
export const isEmployeeOnSheetService = (shift: Shift | undefined, service: 'midi' | 'soir' | 'both', absenceTypes: AbsenceTypeLike[]) => {
    if (service === 'both') {
        const counts = getShiftCounts(shift, absenceTypes);
        return counts.midi > 0 || counts.soir > 0;
    }
    return isEmployeeOnService(shift, service, absenceTypes);
};
